import { useNavigate } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import Section, { Reveal } from './Section'
import BlueprintGrid from './BlueprintGrid'
import { INVITE_HREF, primaryButton, secondaryButton } from './ui'

/** Centred closing call to action over the faded drafting grid. */
export default function ClosingCta() {
  const navigate = useNavigate()
  return (
    <Section labelledBy="cta-title" className="px-5 py-24 text-center md:px-12 md:py-36">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden">
        <BlueprintGrid fade />
        <div className="absolute inset-x-0 top-0 mx-auto h-64 max-w-2xl bg-[radial-gradient(closest-side,rgba(6,182,212,0.18),transparent)] blur-2xl" />
      </div>
      <Reveal className="relative">
        <h2 id="cta-title" className="mx-auto max-w-3xl font-display text-5xl font-semibold leading-[1.02] tracking-[-0.03em] text-slate-50 md:text-7xl">
          Your next part <span className="text-slate-500">starts with a drawing.</span>
        </h2>
        <p className="mx-auto mt-6 max-w-md font-display text-lg text-slate-400">Invite-only while we onboard the first shops. Ask for access and we will set you up.</p>
        <div className="mt-10 flex flex-wrap justify-center gap-3">
          <button type="button" onClick={() => navigate('/login')} className={primaryButton}>Open GCodr <ArrowRight className="h-4 w-4" /></button>
          <a href={INVITE_HREF} className={secondaryButton}>Request an invite</a>
        </div>
      </Reveal>
    </Section>
  )
}
